module.exports = __webpack_public_path__ + "static/media/main idea.3a91862b.mp3";